var path = 'components/displayCondition/details/fieldReference/fieldReference.html';
var html = "<div> <strong>Feld:</strong> {{condition.conditionFieldKey.groupId}}:{{condition.conditionFieldKey.groupIndex}}:{{condition.conditionFieldKey.fieldId}} </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;